import { BooleanInput } from "@/components/admin/boolean-input";
import { DateTimeInput } from "@/components/admin/date-time-input";
import { NumberInput } from "@/components/admin/number-input";
import { SelectInput } from "@/components/admin/select-input";
import { required, useTranslate } from "ra-core";
import { useWatch } from "react-hook-form";

const intervalTypeChoices = [
  { value: "day", label: "resources.tasks.recurrence.every_day" },
  { value: "week", label: "resources.tasks.recurrence.every_week" },
  { value: "month", label: "resources.tasks.recurrence.every_month" },
  { value: "year", label: "resources.tasks.recurrence.every_year" },
  { value: "custom", label: "resources.tasks.recurrence.custom" },
];

const intervalUnitChoices = [
  { value: "day", label: "resources.tasks.recurrence.days" },
  { value: "week", label: "resources.tasks.recurrence.weeks" },
  { value: "month", label: "resources.tasks.recurrence.months" },
  { value: "year", label: "resources.tasks.recurrence.years" },
];

export const RecurringTaskFields = () => {
  const translate = useTranslate();
  const recurringEnabled = useWatch({ name: "recurring_enabled" });
  const intervalType = useWatch({ name: "recurrence_interval_type" }) ?? "day";
  const hasEndDate = useWatch({ name: "recurrence_has_end" });

  if (!recurringEnabled) {
    return (
      <BooleanInput
        source="recurring_enabled"
        label="resources.tasks.recurrence.enabled"
      />
    );
  }

  return (
    <div className="flex flex-col gap-4 border rounded-md p-3">
      <BooleanInput
        source="recurring_enabled"
        label="resources.tasks.recurrence.enabled"
      />

      <SelectInput
        source="recurrence_interval_type"
        choices={intervalTypeChoices}
        optionText="label"
        optionValue="value"
        helperText={false}
        validate={required()}
      />

      {intervalType === "custom" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <NumberInput
            source="recurrence_interval_count"
            min={1}
            defaultValue={1}
            helperText={false}
            validate={required()}
            label="resources.tasks.recurrence.every_count"
          />
          <SelectInput
            source="recurrence_interval_unit"
            choices={intervalUnitChoices}
            optionText="label"
            optionValue="value"
            defaultValue="day"
            helperText={false}
            validate={required()}
            label="resources.tasks.recurrence.every_unit"
          />
        </div>
      )}

      {intervalType !== "custom" && (
        <NumberInput
          source="recurrence_interval_count"
          min={1}
          defaultValue={1}
          helperText={translate("resources.tasks.recurrence.every_count_help")}
          validate={required()}
          label="resources.tasks.recurrence.every_count"
        />
      )}

      <BooleanInput
        source="recurrence_has_end"
        label="resources.tasks.recurrence.has_end_date"
      />

      {hasEndDate && (
        <DateTimeInput
          source="recurrence_ends_at"
          helperText={false}
          validate={required()}
          label="resources.tasks.recurrence.end_date"
        />
      )}
    </div>
  );
};
